import React from "react"
import { useTranslation } from "react-i18next"

interface AppModalShellProps {
  children: React.ReactNode
  onBackdropClick?: () => void
  className?: string
  overlayClassName?: string
  mobileSheet?: boolean
  zIndexClassName?: string
}

const AppModalShell: React.FC<AppModalShellProps> = ({
  children,
  onBackdropClick,
  className = "",
  overlayClassName = "bg-black/40",
  mobileSheet = false,
  zIndexClassName = "z-50",
}) => {
  const { t } = useTranslation("common")
  return (
    <div
      // Re-enable pointer events explicitly: modals can be mounted inside an
      // ancestor with pointer-events-none (e.g. the native floater bar), which
      // would otherwise make every click here fall through to the page behind.
      className={`pointer-events-auto fixed inset-0 ${zIndexClassName} flex justify-center ${mobileSheet ? "items-end p-0 sm:items-center sm:p-4" : "items-center p-4"} ${overlayClassName}`.trim()}
    >
      {onBackdropClick ? (
        <button
          type="button"
          className="absolute inset-0 cursor-default"
          onClick={onBackdropClick}
          aria-label={t("modal.close")}
        />
      ) : null}
      <div className={`relative flex w-full justify-center ${className}`.trim()}>{children}</div>
    </div>
  )
}

export default AppModalShell